import styled, { css } from "styled-components";

const BoldGreen = styled.span(({ theme }) => css`
  font-weight: ${theme.fonts.headingWeight};
  color: ${theme.palette.status.goodAlt};
`);

export default BoldGreen;
